import type { BydaSubmissionPreview } from '@/services/bydaService';

function formatBydaDateTime(value?: string | null): string {
  if (!value) return 'Unknown time';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleString('en-AU', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function buildBydaBlockedMessage(preview: BydaSubmissionPreview): string {
  if (preview.duplicate.isDuplicate && preview.duplicate.matchedRecord) {
    const match = preview.duplicate.matchedRecord;
    return [
      preview.warnings[0] || `A BYDA enquiry already exists for ${preview.duplicate.normalizedAddress}.`,
      `Existing record: #${match.bydaEnquiryId}${match.remoteEnquiryId ? ` / Remote #${match.remoteEnquiryId}` : ''}.`,
      `Created: ${formatBydaDateTime(match.createdDate)}.`,
    ].join(' ');
  }

  if (preview.warnings.length > 0) {
    return preview.warnings.join(' ');
  }

  return 'This BYDA enquiry cannot be submitted right now.';
}

export function buildBydaConfirmationMessage(preview: BydaSubmissionPreview): string {
  const actorLabel = preview.policy.actor.label || 'This user';
  const actorLine = `${actorLabel}: ${preview.policy.actor.usedToday}/${preview.policy.limits.perUserPerDay} used today`;
  const dayLine = `Team today: ${preview.policy.totals.usedToday}/${preview.policy.limits.totalPerDay}`;
  const monthLine = `Month: ${preview.policy.totals.usedThisMonth}/${preview.policy.limits.totalPerMonth}`;
  const duplicateLine = preview.duplicate.isDuplicate
    ? `Existing enquiry found for ${preview.duplicate.normalizedAddress}.`
    : `No prior enquiry found for ${preview.duplicate.normalizedAddress}.`;

  return [
    'Send this BYDA enquiry now?',
    '',
    actorLine,
    dayLine,
    monthLine,
    duplicateLine,
  ].join('\n');
}
